import React, { ReactNode } from 'react';
import { SxProps, Theme, Typography } from '@mui/material';

interface Props {
  readonly children?: ReactNode;
  readonly variant?: any;
  readonly sx?: SxProps<Theme>;
}

/**
 * Used to contain potentially-long blocks of text within a login panel.  It will correctly wrap the contained text and
 *   prevent it from causing the login panel to expand.
 */
export function LoginTypography({ children, variant, sx }: Props) {
  return (
    <Typography
      variant={variant || 'body'}
      sx={[
        { width: 0, minWidth: '100%', display: 'flex', justifyContent: 'center' },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Typography>
  );
}
